import { IWoundMeasurement } from '@alberta/konexi-shared';
import { Inject, Injectable, NgZone } from '@angular/core';
import { WoundMeasurementChannel } from 'src/app/business/wound-measurement/contracts/wound-measurement.channel';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { WoundMeasurementModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class WoundMeasurementSyncService extends SyncService<IWoundMeasurement> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IWoundMeasurement>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(WoundMeasurementModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }
  public canSync(channel: string): boolean {
    return (
      channel === WoundMeasurementChannel.CREATE ||
      channel === WoundMeasurementChannel.EDIT ||
      channel === WoundMeasurementChannel.DELETE
    );
  }
}
